// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","content":"JfPJsvUD","cover":"ejuWUpI1","mobile":"mobile"};